import axios from "axios";
import { getToken } from "./Authentication"; // adjust path if needed

// Default headers (applies to ALL axios calls)
axios.defaults.headers.common["Content-Type"] = "application/json";

// Request interceptor → attach token
axios.interceptors.request.use(
  (config) => {
    const token = getToken();
   if(config?.skipDefaultToken === 'yes') {
    return config;
   } else if (token) {
      const emailId = sessionStorage.getItem('userDetails') ? JSON.parse(sessionStorage.getItem('userDetails'))?.email : '';
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.email = emailId;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor → handle logout globally
axios.interceptors.response.use(
  (response) => {
    const data = response?.data;

    if (data?.success === 0 && data?.logout === true) {
      localStorage.removeItem("token");
      sessionStorage.removeItem("userDetails");
      localStorage.removeItem("UserBusinessDetails");
      window.location.href = "/login";
    }

    return response;
  },
  (error) => Promise.reject(error)
);
